import { render, staticRenderFns } from "./boarding-pipeline.vue?vue&type=template&id=ba7209f6&"
import script from "./boarding-pipeline.vue?vue&type=script&lang=js&"
export * from "./boarding-pipeline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports